import { css, useTheme } from '@emotion/react'
import { Link } from '../base-ui'
import {
    IoLogoWhatsapp,
    IoLogoTwitter,
    IoLogoYoutube,
    IoLogoLinkedin,
    IoLogoRss,
} from 'react-icons/io'
import { AiFillInstagram } from 'react-icons/ai'
import { FaTelegramPlane, FaMobileAlt, FaPhone } from 'react-icons/fa'
import { IoMail } from 'react-icons/io5'

export const switchSocial = (socialType) => {
    switch (socialType) {
        case 'mobile':
            return <FaMobileAlt />
        case 'phone':
            return <FaPhone />
        case 'whatsapp':
            return <IoLogoWhatsapp />
        case 'instagram':
            return <AiFillInstagram />
        case 'twitter':
            return <IoLogoTwitter />
        case 'youtube':
            return <IoLogoYoutube />
        case 'linkedin':
            return <IoLogoLinkedin />
        case 'telegram':
            return <FaTelegramPlane />
        case 'rss':
            return <IoLogoRss />
        case 'email':
            return <IoMail />
    }
}

function SocialLinks({ style, socials, color, hoverColor }) {
    const theme = useTheme()
    const footerColor = theme.colors.websiteFooter.color
    const footerHoverColor = theme.colors.websiteFooter.hover
    const socialStyle = css`
        display: flex;
        ${style}
    `

    return (
        <div css={socialStyle}>
            {socials?.filter(Boolean)?.map((social, idx) => (
                <Link
                    key={idx}
                    color={color || footerColor}
                    hoverColor={hoverColor || footerHoverColor}
                    href={social?.href}
                    className="p-2"
                    external={social?.href?.indexOf('/') !== 0}
                >
                    <span className="text-2xl social-icon">
                        {/* <IoLogoWhatsapp /> */}
                        {switchSocial(social?.name)}
                    </span>
                </Link>
            ))}
        </div>
    )
}

export default SocialLinks
